import React from 'react';
import classNames from 'classnames';
import VerifiedIcon from 'icons/Verified.icon';

import './VerifiedBadge.styles.scss';

type VerifiedBadgeProps = {
  className?: string;
  text?: string;
};

const VerifiedBadge: React.FC<VerifiedBadgeProps> = (props) => {
  const { className, text } = props;

  const classes = classNames(
    'verified-badge',
    { 'verified-badge--small': !text },
    className,
  );

  return (
    <div className={classes}>
      <VerifiedIcon />
      {text && <span>{text}</span>}
    </div>
  );
};

export default VerifiedBadge;
